"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditTransformationSchema = exports.FieldModificationSchema = exports.RenameFieldModificationSchema = exports.DeletedFieldModificationSchema = exports.FormulaFieldModificationSchema = exports.AbstractFieldModificationSchema = exports.FlattenTransformationSchema = exports.AggregationFieldSchema = exports.StackTransformationSchema = exports.JoinTransformationSchema = exports.JoinFieldSchema = exports.FilterTransformationSchema = exports.Asset2JsonTransformationSchema = exports.Asset2JsonEngineSchema = exports.Pdf2CsvTransformationSchema = exports.PDFFieldQuerySchema = exports.UnzipTransformationSchema = exports.CleanUpConfigSchema = exports.AttachHeaderTransformationSchema = exports.Xlsx2CsvTransformationSchema = exports.Xlsx2CsvTransformationExtractValuesSchema = exports.ExtractValuesConfigSchema = exports.Xlsx2CsvTransformationConvertRangeSchema = exports.ConvertRangeConfigSchema = exports.Ai2CsvTransformationSchema = exports.ExtractionStruct = exports.PyCsvVirtualSheetTransformationSchema = exports.PyXlsxVirtualSheet2CsvTransformationSchema = exports.PreFilterTransformationSchema = exports.PreFilterConfigSchema = exports.Xlsx2Csv2TransformationSchema = exports.Xlsx2Csv2TransformationExtractValuesSchema = exports.PyXlsx2Csv2TransformationSchema = exports.PyXlsx2Csv2ConfigSchema = exports.PyXlsx2Csv2ExtractValuesSchema = exports.PyXlsx2Csv2ConvertRangeSchema = exports.Xlsx2Csv2TransformationConvertRangeSchema = exports.Xlsx2Csv2TransformationBaseSchema = exports.RangeXlsxConfigSchema = exports.ValuesXlsxConfigSchema = exports.ImportFormatSchema = exports.Xlsx2CsvTransformationBaseSchema = exports.ExtractValueConfigSchema = exports.SanitizeTransformationSchema = exports.AbstractBaseTransformationSchema = exports.TransformOperationSchema = exports.TapeDefinitionSchema = void 0;
const zod_1 = require("zod");
const finley_types_1 = require("@finley-technologies/finley-types");
const Ai2CsvBaseFieldsTemplateStruct = zod_1.z.enum([
    'balanceSheet',
    'incomeStatement',
]);
// TapeDefinition
exports.TapeDefinitionSchema = zod_1.z
    .object({
    isJson: zod_1.z
        .boolean()
        .optional()
        .describe('@asset2json: mark JSON‐tape definitions'),
    baseFields: zod_1.z
        .array(finley_types_1.DataTapeField.BaseConfigSchema)
        .describe('Base field configurations'),
    delimiter: zod_1.z.string().describe('CSV delimiter (e.g. ",", "|", "\\t")'),
    sanitizedFieldNames: zod_1.z
        .boolean()
        .describe('Whether field names are snake_cased'),
})
    .describe('TapeDefinition');
// TransformOperation
exports.TransformOperationSchema = zod_1.z
    .enum([
    'attachHeader',
    'xlsx2csv',
    'xlsx2csv2',
    'pyXlsx2Csv2',
    'pyXlsxVirtualSheet2Csv',
    'pyCsvVirtualSheet',
    'pdf2csv',
    'asset2json',
    'sanitize',
    'preFilter',
    'filter',
    'join',
    'flatten',
    'unzip',
    'stack',
    'edit',
    'ai2Csv',
])
    .describe('Transformation operation');
// AbstractBaseTransformation
exports.AbstractBaseTransformationSchema = zod_1.z
    .object({
    srcDataTape: exports.TapeDefinitionSchema.nullable(),
    operation: exports.TransformOperationSchema,
})
    .describe('Common fields for all transformations');
// SanitizeTransformation
exports.SanitizeTransformationSchema = exports.AbstractBaseTransformationSchema.extend({
    operation: zod_1.z.literal('sanitize'),
    srcDataTape: exports.TapeDefinitionSchema.omit({ sanitizedFieldNames: true }),
    sanitizeFieldNames: zod_1.z
        .boolean()
        .describe('Whether to snake_case field names'),
}).describe('Sanitize transformation');
// ExtractValueConfig
exports.ExtractValueConfigSchema = zod_1.z
    .object({
    sheetName: zod_1.z
        .string()
        .describe('Sheet name in xls (supports regex if not exact)'),
    fieldName: zod_1.z.string().describe('Header name for the single-row CSV'),
    cellAddress: zod_1.z.string().describe('Cell address in A1 notation (e.g. A1)'),
    importRaw: zod_1.z
        .boolean()
        .describe('Whether to skip formatting when extracting value'),
})
    .describe('ExtractValueConfig');
// Xlsx2CsvTransformationBase
exports.Xlsx2CsvTransformationBaseSchema = exports.AbstractBaseTransformationSchema.extend({
    srcDataTape: zod_1.z.null(),
    operation: zod_1.z.literal('xlsx2csv'),
    mode: zod_1.z
        .enum(['convertRange', 'extractValues'])
        .describe('Mode: convert header+rows or extract single values'),
}).describe('Base for xlsx2csv transformation');
exports.ImportFormatSchema = zod_1.z
    .enum(['raw', 'formatted', 'formula'])
    .describe('Import format for XLSX fields');
exports.ValuesXlsxConfigSchema = zod_1.z
    .object({
    importFormat: exports.ImportFormatSchema.describe('Represents format when importing field'),
    sheetName: zod_1.z.string().describe('Name of the sheet in Xlsx file'),
    isSheetNameRegex: zod_1.z
        .boolean()
        .optional()
        .describe('If true, sheetName is treated as regex'),
    cell: zod_1.z
        .string()
        .optional()
        .describe('@deprecated: use cellRange; single cell in A1 notation'),
    cellRange: zod_1.z
        .string()
        .optional()
        .describe('Range of cells to be extracted (e.g., "A12" or "A12:A14")'),
})
    .describe('Values XLSX Field Config');
const ValuesXlsxFieldConfigSchema = zod_1.z.discriminatedUnion('type', [
    zod_1.z.object({
        ...finley_types_1.DataTapeField.BooleanConfigSchema.shape,
        ...exports.ValuesXlsxConfigSchema.shape,
    }),
    zod_1.z.object({
        ...finley_types_1.DataTapeField.OptionalBooleanConfigSchema.shape,
        ...exports.ValuesXlsxConfigSchema.shape,
    }),
    zod_1.z.object({
        ...finley_types_1.DataTapeField.CurrencyConfigSchema.shape,
        ...exports.ValuesXlsxConfigSchema.shape,
    }),
    zod_1.z.object({
        ...finley_types_1.DataTapeField.OptionalCurrencyConfigSchema.shape,
        ...exports.ValuesXlsxConfigSchema.shape,
    }),
    zod_1.z.object({
        ...finley_types_1.DataTapeField.DateConfigSchema.shape,
        ...exports.ValuesXlsxConfigSchema.shape,
    }),
    zod_1.z.object({
        ...finley_types_1.DataTapeField.OptionalDateConfigSchema.shape,
        ...exports.ValuesXlsxConfigSchema.shape,
    }),
    zod_1.z.object({
        ...finley_types_1.DataTapeField.DateTimeConfigSchema.shape,
        ...exports.ValuesXlsxConfigSchema.shape,
    }),
    zod_1.z.object({
        ...finley_types_1.DataTapeField.OptionalDateTimeConfigSchema.shape,
        ...exports.ValuesXlsxConfigSchema.shape,
    }),
    zod_1.z.object({
        ...finley_types_1.DataTapeField.FloatConfigSchema.shape,
        ...exports.ValuesXlsxConfigSchema.shape,
    }),
    zod_1.z.object({
        ...finley_types_1.DataTapeField.OptionalFloatConfigSchema.shape,
        ...exports.ValuesXlsxConfigSchema.shape,
    }),
    zod_1.z.object({
        ...finley_types_1.DataTapeField.IntegerConfigSchema.shape,
        ...exports.ValuesXlsxConfigSchema.shape,
    }),
    zod_1.z.object({
        ...finley_types_1.DataTapeField.OptionalIntegerConfigSchema.shape,
        ...exports.ValuesXlsxConfigSchema.shape,
    }),
    zod_1.z.object({
        ...finley_types_1.DataTapeField.PercentageConfigSchema.shape,
        ...exports.ValuesXlsxConfigSchema.shape,
    }),
    zod_1.z.object({
        ...finley_types_1.DataTapeField.OptionalPercentageConfigSchema.shape,
        ...exports.ValuesXlsxConfigSchema.shape,
    }),
    zod_1.z.object({
        ...finley_types_1.DataTapeField.StringConfigSchema.shape,
        ...exports.ValuesXlsxConfigSchema.shape,
    }),
    zod_1.z.object({
        ...finley_types_1.DataTapeField.OptionalStringConfigSchema.shape,
        ...exports.ValuesXlsxConfigSchema.shape,
    }),
]);
exports.RangeXlsxConfigSchema = zod_1.z
    .object({
    importFormat: exports.ImportFormatSchema.describe('Represents format when importing field'),
    exclude: zod_1.z.string().array().optional().describe(`String values to filter out.
          If any of these values are found in the column, the row will be excluded.
          for ignoring null and undefined values, use 'jsNull' and 'jsUndefined' in your excludes`),
    excludeIsRegex: zod_1.z
        .boolean()
        .optional()
        .describe('If true, exclude values will be treated as regex. If false (or unspecified), the exclude values will be treated as exact match.'),
})
    .describe('Values XLSX Field Config');
// RangeXlsxFieldConfig
const RangeXlsxFieldConfigSchema = zod_1.z.discriminatedUnion('type', [
    zod_1.z.object({
        ...finley_types_1.DataTapeField.BooleanConfigSchema.shape,
        ...exports.RangeXlsxConfigSchema.shape,
    }),
    zod_1.z.object({
        ...finley_types_1.DataTapeField.OptionalBooleanConfigSchema.shape,
        ...exports.RangeXlsxConfigSchema.shape,
    }),
    zod_1.z.object({
        ...finley_types_1.DataTapeField.CurrencyConfigSchema.shape,
        ...exports.RangeXlsxConfigSchema.shape,
    }),
    zod_1.z.object({
        ...finley_types_1.DataTapeField.OptionalCurrencyConfigSchema.shape,
        ...exports.RangeXlsxConfigSchema.shape,
    }),
    zod_1.z.object({
        ...finley_types_1.DataTapeField.DateConfigSchema.shape,
        ...exports.RangeXlsxConfigSchema.shape,
    }),
    zod_1.z.object({
        ...finley_types_1.DataTapeField.OptionalDateConfigSchema.shape,
        ...exports.RangeXlsxConfigSchema.shape,
    }),
    zod_1.z.object({
        ...finley_types_1.DataTapeField.DateTimeConfigSchema.shape,
        ...exports.RangeXlsxConfigSchema.shape,
    }),
    zod_1.z.object({
        ...finley_types_1.DataTapeField.OptionalDateTimeConfigSchema.shape,
        ...exports.RangeXlsxConfigSchema.shape,
    }),
    zod_1.z.object({
        ...finley_types_1.DataTapeField.FloatConfigSchema.shape,
        ...exports.RangeXlsxConfigSchema.shape,
    }),
    zod_1.z.object({
        ...finley_types_1.DataTapeField.OptionalFloatConfigSchema.shape,
        ...exports.RangeXlsxConfigSchema.shape,
    }),
    zod_1.z.object({
        ...finley_types_1.DataTapeField.IntegerConfigSchema.shape,
        ...exports.RangeXlsxConfigSchema.shape,
    }),
    zod_1.z.object({
        ...finley_types_1.DataTapeField.OptionalIntegerConfigSchema.shape,
        ...exports.RangeXlsxConfigSchema.shape,
    }),
    zod_1.z.object({
        ...finley_types_1.DataTapeField.PercentageConfigSchema.shape,
        ...exports.RangeXlsxConfigSchema.shape,
    }),
    zod_1.z.object({
        ...finley_types_1.DataTapeField.OptionalPercentageConfigSchema.shape,
        ...exports.RangeXlsxConfigSchema.shape,
    }),
    zod_1.z.object({
        ...finley_types_1.DataTapeField.StringConfigSchema.shape,
        ...exports.RangeXlsxConfigSchema.shape,
    }),
    zod_1.z.object({
        ...finley_types_1.DataTapeField.OptionalStringConfigSchema.shape,
        ...exports.RangeXlsxConfigSchema.shape,
    }),
]);
// Xlsx2Csv2TransformationBase
exports.Xlsx2Csv2TransformationBaseSchema = exports.AbstractBaseTransformationSchema.extend({
    srcDataTape: zod_1.z.literal(null),
    operation: zod_1.z.literal('xlsx2csv2'),
    mode: zod_1.z
        .enum(['convertRange', 'extractValues'])
        .describe('Mode: convert header+rows or extract single values'),
}).describe('Base for xlsx2csv2 transformation');
exports.Xlsx2Csv2TransformationConvertRangeSchema = exports.Xlsx2Csv2TransformationBaseSchema.extend({
    mode: zod_1.z.literal('convertRange').describe('Mode: convert header+rows'),
    sanitizeFieldNames: zod_1.z
        .boolean()
        .optional()
        .describe('Whether to snake_case field names'),
    sheetName: zod_1.z.string().describe('Name of the sheet in Xlsx file'),
    useDenseMode: zod_1.z.boolean().optional().describe('Whether to use dense mode'),
    isSheetNameRegex: zod_1.z
        .boolean()
        .optional()
        .describe('If true, sheetName is treated as regex'),
    headerRange: zod_1.z
        .string()
        .describe('Header range in A1 notation (single row)'),
    dataEndRange: zod_1.z
        .string()
        .optional()
        .describe('Last data row range in A1 notation'),
    fields: zod_1.z
        .array(RangeXlsxFieldConfigSchema)
        .min(1)
        .describe('Columns to extract'),
}).describe('Xlsx2Csv2TransformationConvertRange');
exports.PyXlsx2Csv2ConvertRangeSchema = zod_1.z
    .object({
    operation: zod_1.z.literal('pyXlsx2Csv2'),
    mode: zod_1.z.literal('convertRange'),
    sheetName: zod_1.z.string().describe('Name of the sheet in Xlsx file'),
    isSheetNameRegex: zod_1.z
        .boolean()
        .optional()
        .describe('If true, sheetName is treated as regex'),
    headerRange: zod_1.z.string().describe(`
   * specify headerRange that identifies the row(s) where headers are
   * You can reference values in any of the headers to identify the column when configuring fields.
   * this must be a range in A1 notation that spans the header row(s). Typically it would be a single
   * row, but if your headers spans across multiple rows, you can specify range of rows.
   * e.g. 'B2:Z2'
   * The data will be extracted starting from the row after headerRange
        `),
    dataEndRange: zod_1.z.string().optional().describe(`
   * you can optionally specify the last row to be used to extract values.
   * without dataEndRange all the rows after headerRange will be converted to csv.
   * dataEndRange lets us specify exact range to be converted to csv
   * dataRange must be in A1 notation,and must span just one row.
   * e.g. 'B30:Z30'
   * if unspecified, the entire sheet will be converted to csv
        `),
})
    .describe('PyXlsx2Csv2ConvertRangeConfig');
exports.PyXlsx2Csv2ExtractValuesSchema = zod_1.z
    .object({
    operation: zod_1.z.literal('pyXlsx2Csv2'),
    mode: zod_1.z.literal('extractValues'),
    sheetName: zod_1.z.string().describe('Name of the sheet in Xlsx file'),
    fields: zod_1.z
        .array(zod_1.z.object({
        field: zod_1.z.string().describe('Field name in the resulting data tape'),
        cellAddress: zod_1.z
            .string()
            .describe('Cell address within `sheetName` from which to pull the value'),
    }))
        .min(1)
        .describe('Fields to extract from the XLSX file'),
})
    .describe('PyXlsx2Csv2ExtractValuesConfig');
exports.PyXlsx2Csv2ConfigSchema = zod_1.z
    .discriminatedUnion('mode', [
    exports.PyXlsx2Csv2ConvertRangeSchema,
    exports.PyXlsx2Csv2ExtractValuesSchema,
])
    .describe('PyXlsx2Csv2Config');
// Note: despite the name, PyXlsx2Csv2 has more in common with the original
// Xlsx2Csv (as opposed to Xlsx2Csv2). Notably, like the original Xlsx2Csv,
// sanitization will need to occur in a separate node.
exports.PyXlsx2Csv2TransformationSchema = zod_1.z
    .intersection(exports.AbstractBaseTransformationSchema.extend({
    srcDataTape: zod_1.z.literal(null),
    operation: zod_1.z.literal('pyXlsx2Csv2'),
}), exports.PyXlsx2Csv2ConfigSchema)
    .describe('PyXlsx2Csv2Transformation');
exports.Xlsx2Csv2TransformationExtractValuesSchema = exports.Xlsx2Csv2TransformationBaseSchema.extend({
    mode: zod_1.z.literal('extractValues').describe('Mode: extract single values'),
    useDenseMode: zod_1.z.boolean().optional().describe('Whether to use dense mode'),
    fields: zod_1.z
        .array(ValuesXlsxFieldConfigSchema)
        .min(1)
        .describe('Fields to extract'),
}).describe('Xlsx2Csv2TransformationExtractValues');
exports.Xlsx2Csv2TransformationSchema = zod_1.z
    .discriminatedUnion('mode', [
    exports.Xlsx2Csv2TransformationConvertRangeSchema,
    exports.Xlsx2Csv2TransformationExtractValuesSchema,
])
    .describe('Xlsx2CsvTransformation');
exports.PreFilterConfigSchema = zod_1.z
    .object({
    exclude: zod_1.z
        .array(zod_1.z.object({
        field: zod_1.z.string().describe('Field name to filter on'),
        values: zod_1.z.array(zod_1.z.string()).describe('Values to filter out'),
    }))
        .describe('Conditions to filter out rows'),
})
    .describe('PreFilterConfig');
exports.PreFilterTransformationSchema = exports.AbstractBaseTransformationSchema.extend({
    srcDataTape: zod_1.z.literal(null),
    operation: zod_1.z.literal('preFilter'),
    exclude: zod_1.z
        .array(zod_1.z.object({
        field: zod_1.z.string().describe('Field name to filter on'),
        values: zod_1.z.array(zod_1.z.string()).describe('Values to filter out'),
    }))
        .describe('Conditions to filter out rows'),
}).describe('PreFilterTransformation');
exports.PyXlsxVirtualSheet2CsvTransformationSchema = exports.AbstractBaseTransformationSchema.extend({
    srcDataTape: zod_1.z.null(),
    operation: zod_1.z.literal('pyXlsxVirtualSheet2Csv'),
    fields: zod_1.z.array(finley_types_1.DataTapeField.BaseConfigSchema),
    sheets: zod_1.z.array(zod_1.z.object({
        sheetName: zod_1.z.string(),
        rows: zod_1.z.int().describe('number of rows to extract starting from row 1'),
        endColumn: zod_1.z.string().optional().describe(`ending letter of columns to extract, optional
        if undefined, extract all columns with text for provided rows
        if defined, text MUST exist at least out to that column, otherwise pandas will throw`),
    })),
    virtualSheet: zod_1.z.array(zod_1.z.array(finley_types_1.Util.SqlPrimitiveStruct))
        .describe(`virtual sheet is a 2D Array of strings
    the author of the configuration is expected to create the "csv" they want in excel
    and we will copy into this configuration
    the first row should be column headers, subsequent rows can string, numbers, formulas, etc
    use "=SUM(Sheet1!A1, Sheet!A2)" for formulas
    FORMULAS MUST BE FULLY QUALIFIED WITH SHEET NAME`),
}).describe('PyXlsxVirtualSheet2Csv');
exports.PyCsvVirtualSheetTransformationSchema = exports.AbstractBaseTransformationSchema.extend({
    srcDataTape: zod_1.z.null(),
    operation: zod_1.z.literal('pyCsvVirtualSheet'),
    fields: zod_1.z.array(finley_types_1.DataTapeField.BaseConfigSchema),
    virtualSheet: zod_1.z.array(zod_1.z.array(finley_types_1.Util.SqlPrimitiveStruct))
        .describe(`virtual sheet is a 2D Array of strings
    the author of the configuration is expected to create the "csv" they want in excel
    and we will copy into this configuration
    the first row should be column headers, subsequent rows can string, numbers, formulas, etc
    use "=SUM(Sheet1!A1, Sheet!A2)" for formulas
    FORMULAS MUST BE FULLY QUALIFIED WITH SHEET NAME. Input artifactSlugs will be used as sheet names`),
}).describe('PyCsvVirtualSheet2');
const CsvExtractionStruct = zod_1.z.object({ fileExt: zod_1.z.literal('csv') });
const JsonExtractionStruct = zod_1.z.object({ fileExt: zod_1.z.literal('json') });
const HtmlExtractionStruct = zod_1.z.object({
    fileExt: zod_1.z.literal('html'),
    engine: zod_1.z.enum(['beautifulSoup', 'raw']).optional(), // default to beautifulSoup, raw passes html directly to LLM
});
const ImageExtractionStruct = zod_1.z.object({
    fileExt: zod_1.z.enum(['png', 'jpeg', 'jpg', 'tif', 'tiff']),
    engine: zod_1.z.enum(['textract']).optional(),
});
const SheetExtractionConfigStruct = zod_1.z.object({
    sheetName: zod_1.z.string(),
    startRow: zod_1.z.int().optional(), // default to row 1
    endRow: zod_1.z.int().optional(), // default to all rows
    startColumn: zod_1.z.string().optional(), // default to A
    endColumn: zod_1.z.string().optional(), // default to last column with text, if provided, TEXT must exist AT LEAST until that column
});
const SheetExtractionConfigsStruct = zod_1.z.array(SheetExtractionConfigStruct);
const XlsxExtractionStruct = zod_1.z.object({
    fileExt: zod_1.z.literal('xlsx'),
    engine: zod_1.z.enum(['openpyxl']).optional(), // default openpyxl (only supported engine currently)
    sheets: SheetExtractionConfigsStruct.optional(), // preferably we always configure this, but won't enforce
});
const XlsbExtractionStruct = zod_1.z.object({
    fileExt: zod_1.z.literal('xlsb'),
    engine: zod_1.z.enum(['pyxlsb']).optional(), // default pyxlsb (only supported engine currently)
    sheets: SheetExtractionConfigsStruct.optional(), // preferably we always configure this, but won't enforce
});
const PdfExtractionStruct = zod_1.z.object({
    fileExt: zod_1.z.literal('pdf'),
    engine: zod_1.z.enum(['pdfMiner', 'textract']).optional(),
    pages: zod_1.z.array(zod_1.z.int()).optional(),
});
exports.ExtractionStruct = zod_1.z.discriminatedUnion('fileExt', [
    CsvExtractionStruct,
    JsonExtractionStruct,
    PdfExtractionStruct,
    HtmlExtractionStruct,
    ImageExtractionStruct,
    XlsxExtractionStruct,
    XlsbExtractionStruct,
]);
const Ai2CsvDocumentExtractionStruct = zod_1.z.object({
    artifactSlug: zod_1.z.string(),
    configuration: exports.ExtractionStruct, // overwrite defaults, or configure more explicitly
});
exports.Ai2CsvTransformationSchema = exports.AbstractBaseTransformationSchema.extend({
    srcDataTape: exports.TapeDefinitionSchema.nullable(),
    operation: zod_1.z.literal('ai2Csv'),
    fields: zod_1.z.array(finley_types_1.DataTapeField.BaseConfigSchema).optional(),
    prompt: zod_1.z.string(),
    documents: zod_1.z.array(Ai2CsvDocumentExtractionStruct).optional(), // if undefined, uses all with defaults
    baseFieldsTemplate: Ai2CsvBaseFieldsTemplateStruct.optional(),
}).describe('Ai2CsvTransform');
// ConvertRangeConfig
exports.ConvertRangeConfigSchema = zod_1.z
    .object({
    sheetName: zod_1.z
        .string()
        .describe('Name of sheet in xls file (supports regex if name not exact)'),
    headerRange: zod_1.z
        .string()
        .nullable()
        .describe('Header range in A1 notation (single row)'),
    dataEndRange: zod_1.z
        .string()
        .optional()
        .describe('Last data row range in A1 notation'),
    importRaw: zod_1.z
        .boolean()
        .optional()
        .describe('Import raw values (except dates) when true, else formatted values'),
    formula: zod_1.z
        .boolean()
        .optional()
        .describe('Emit formulas instead of values if true'),
})
    .describe('ConvertRangeConfig');
exports.Xlsx2CsvTransformationConvertRangeSchema = exports.Xlsx2CsvTransformationBaseSchema.extend({
    mode: zod_1.z.literal('convertRange').describe('Mode: convert header+rows'),
})
    .merge(exports.ConvertRangeConfigSchema)
    .describe('Xlsx2CsvTransformationConvertRange');
// ExtractValuesConfig
exports.ExtractValuesConfigSchema = zod_1.z
    .object({
    sheetName: zod_1.z
        .string()
        .describe('Name of the sheet in Xlsx file (supports regex if not exact)'),
    fieldName: zod_1.z
        .string()
        .describe('Field name to assign for this value.This will become the header for the single row csv'),
    cellAddress: zod_1.z.string().describe('Cell address in A1 notation (e.g. A1)'),
    importRaw: zod_1.z
        .boolean()
        .describe('If true, imported config will not include any xls formatting'),
})
    .describe('Extract Values Config');
exports.Xlsx2CsvTransformationExtractValuesSchema = exports.Xlsx2CsvTransformationBaseSchema.extend({
    mode: zod_1.z.literal('extractValues').describe('Mode: extract single values'),
    extract: zod_1.z
        .array(exports.ExtractValuesConfigSchema)
        .min(1)
        .describe('Fields to extract from the XLSX file'),
}).describe('Xlsx2CsvTransformationExtractValues');
exports.Xlsx2CsvTransformationSchema = zod_1.z
    .discriminatedUnion('mode', [
    exports.Xlsx2CsvTransformationConvertRangeSchema,
    exports.Xlsx2CsvTransformationExtractValuesSchema,
])
    .describe('Xlsx2CsvTransformation');
exports.AttachHeaderTransformationSchema = exports.AbstractBaseTransformationSchema.extend({
    srcDataTape: zod_1.z.literal(null),
    operation: zod_1.z.literal('attachHeader'),
    fields: zod_1.z
        .array(zod_1.z.string())
        .min(1)
        .describe('Fields to be attached to the csv header'),
    delimiter: zod_1.z
        .string()
        .min(1)
        .max(1)
        .optional()
        .describe('Separator to be used to join the fields. Default is comma'),
}).describe('AttachHeaderTransformation');
exports.CleanUpConfigSchema = zod_1.z
    .object({
    startOffset: zod_1.z.number().describe(`
   * determines start index of the data to be cleaned
   * if 0 or +value, the this is assumed to be offset from
   * the start the buffer
   * if -value, the this is assumed to be offset from the end of the buffer
   * if value -1, the data will be cleaned from the end
   * example:
   * 0: whole buffer will be cleaned
   * 9: 1st 10 charactes will be skipped, rest will be cleaned
   * -1: only last character will be cleaned
   * -9: last 9 characters will be cleaned
        `),
})
    .describe('Configuration for cleaning up non-utf8 characters from the input buffer');
/**
 * file to be extracted
 * must be full path within the zip file
 * e.g. 'toplevel.csv', 'folder1/file1.csv'
 * if the zip contains a single file, file can be omitted.
 */
exports.UnzipTransformationSchema = exports.AbstractBaseTransformationSchema.extend({
    srcDataTape: zod_1.z.literal(null),
    operation: zod_1.z.literal('unzip'),
    file: zod_1.z.string().optional().describe(`
   * file to be extracted
   * must be full path within the zip file
   * e.g. 'toplevel.csv', 'folder1/file1.csv'
   * if the zip contains a single file, file can be omitted.
    `),
    compression: zod_1.z
        .enum(['gz', 'zip'])
        .optional()
        .describe('Compression to use. Defaults to zip.'),
    cleanupUTF8: exports.CleanUpConfigSchema.optional().describe('Configuration for cleaning up non-utf8 characters from the input buffer.'),
});
exports.PDFFieldQuerySchema = zod_1.z
    .object({
    question: zod_1.z.string().describe('Question to ask PDF'),
    pageNumbers: zod_1.z
        .array(zod_1.z.number().int())
        .min(1)
        .describe('List of page numbers on which to ask the question. If multiple page numbers are provided, the first page with a valid answer will be used. All questions must have same number of page numbers specified.'),
    name: zod_1.z.string().describe('Field name to store answer in'),
})
    .describe('PDFFieldQuerySchema');
exports.Pdf2CsvTransformationSchema = exports.AbstractBaseTransformationSchema.extend({
    srcDataTape: zod_1.z.literal(null),
    operation: zod_1.z.literal('pdf2csv'),
    fields: zod_1.z.array(exports.PDFFieldQuerySchema).min(1),
});
const asset2JsonQuestionSchema = zod_1.z.object({
    question: zod_1.z.string().describe('Question to ask PDF'),
    pageNumbers: zod_1.z
        .array(zod_1.z.number().int())
        .min(1)
        .describe('List of page numbers on which to ask the question. If multiple page numbers are provided, the first page with a valid answer will be used. All questions must have same number of page numbers specified.'),
});
const Asset2JsonFieldQuerySchema = zod_1.z
    .discriminatedUnion('type', [
    zod_1.z.object({
        ...finley_types_1.DataTapeField.BooleanConfigSchema.shape,
        ...asset2JsonQuestionSchema.shape,
    }),
    zod_1.z.object({
        ...finley_types_1.DataTapeField.OptionalBooleanConfigSchema.shape,
        ...asset2JsonQuestionSchema.shape,
    }),
    zod_1.z.object({
        ...finley_types_1.DataTapeField.CurrencyConfigSchema.shape,
        ...asset2JsonQuestionSchema.shape,
    }),
    zod_1.z.object({
        ...finley_types_1.DataTapeField.OptionalCurrencyConfigSchema.shape,
        ...asset2JsonQuestionSchema.shape,
    }),
    zod_1.z.object({
        ...finley_types_1.DataTapeField.DateConfigSchema.shape,
        ...asset2JsonQuestionSchema.shape,
    }),
    zod_1.z.object({
        ...finley_types_1.DataTapeField.OptionalDateConfigSchema.shape,
        ...asset2JsonQuestionSchema.shape,
    }),
    zod_1.z.object({
        ...finley_types_1.DataTapeField.DateTimeConfigSchema.shape,
        ...asset2JsonQuestionSchema.shape,
    }),
    zod_1.z.object({
        ...finley_types_1.DataTapeField.OptionalDateTimeConfigSchema.shape,
        ...asset2JsonQuestionSchema.shape,
    }),
    zod_1.z.object({
        ...finley_types_1.DataTapeField.FloatConfigSchema.shape,
        ...asset2JsonQuestionSchema.shape,
    }),
    zod_1.z.object({
        ...finley_types_1.DataTapeField.OptionalFloatConfigSchema.shape,
        ...asset2JsonQuestionSchema.shape,
    }),
    zod_1.z.object({
        ...finley_types_1.DataTapeField.IntegerConfigSchema.shape,
        ...asset2JsonQuestionSchema.shape,
    }),
    zod_1.z.object({
        ...finley_types_1.DataTapeField.OptionalIntegerConfigSchema.shape,
        ...asset2JsonQuestionSchema.shape,
    }),
    zod_1.z.object({
        ...finley_types_1.DataTapeField.PercentageConfigSchema.shape,
        ...asset2JsonQuestionSchema.shape,
    }),
    zod_1.z.object({
        ...finley_types_1.DataTapeField.OptionalPercentageConfigSchema.shape,
        ...asset2JsonQuestionSchema.shape,
    }),
    zod_1.z.object({
        ...finley_types_1.DataTapeField.StringConfigSchema.shape,
        ...asset2JsonQuestionSchema.shape,
    }),
    zod_1.z.object({
        ...finley_types_1.DataTapeField.OptionalStringConfigSchema.shape,
        ...asset2JsonQuestionSchema.shape,
    }),
])
    .describe('Union of all Asset2Json base fields');
exports.Asset2JsonEngineSchema = zod_1.z
    .enum(['finleyAi', 'textract', 'htmlTags'])
    .describe('Valid Asset2Json engine types');
exports.Asset2JsonTransformationSchema = exports.AbstractBaseTransformationSchema.extend({
    srcDataTape: zod_1.z.literal(null),
    operation: zod_1.z.literal('asset2json'),
    engine: exports.Asset2JsonEngineSchema,
    finleyAiExtractionEngine: finley_types_1.FinleyAi.FinleyAiExtractValuesEngineSchema.optional(),
    fields: zod_1.z
        .array(Asset2JsonFieldQuerySchema)
        .min(1)
        .describe('Fields to extract from the asset. Each field must have a question and a list of page numbers.'),
}).describe('Asset2JsonTransformation');
exports.FilterTransformationSchema = exports.AbstractBaseTransformationSchema.extend({
    srcDataTape: exports.TapeDefinitionSchema,
    operation: zod_1.z.literal('filter'),
    filterFormula: zod_1.z.string().describe('Filter formula to apply to the tape.'),
}).describe('FilterTransformation');
exports.JoinFieldSchema = zod_1.z.object({
    field: zod_1.z.string().describe('Field to join from joinDataTape'),
    defaultTo: zod_1.z
        .string()
        .optional()
        .describe('Default value to use if join row is missing. If not specified, will throw error on missing join row.'),
});
exports.JoinTransformationSchema = exports.AbstractBaseTransformationSchema.extend({
    srcDataTape: exports.TapeDefinitionSchema,
    operation: zod_1.z.literal('join'),
    joinOnField: zod_1.z.string().describe('Field to join on'),
    joinDataTape: exports.TapeDefinitionSchema.describe('Data tape defining join data. Must have the same field as srcDataTape.joinOnField.'),
    errorOnMissingJoinRow: zod_1.z
        .boolean()
        .describe('If true, will throw error on missing join row, if false, will use joinFields[n].defaultTo values'),
    joinFields: zod_1.z
        .array(exports.JoinFieldSchema)
        .min(1)
        .describe('Fields to join from joinDataTape. Each field must have a field name and an optional defaultTo value.'),
}).describe('JoinTransformation');
exports.StackTransformationSchema = exports.AbstractBaseTransformationSchema.extend({
    srcDataTape: exports.TapeDefinitionSchema,
    operation: zod_1.z.literal('stack'),
    otherDataTapes: zod_1.z
        .array(exports.TapeDefinitionSchema)
        .min(1)
        .describe('Other tapes to stack.'),
    ensureUniqueFields: zod_1.z
        .array(zod_1.z.string())
        .describe('Fields to ensure unique values for. Typically primary key fields like `id`, `externalReceivableId`.'),
}).describe('StackTransformation');
exports.AggregationFieldSchema = zod_1.z.object({
    inputField: zod_1.z.string().describe('Field to aggregate'),
    outputField: zod_1.z.string().describe('Field to store aggregated value'),
    aggregationFunction: zod_1.z
        .enum(['sum'])
        .describe('Aggregation function to apply to the field'),
});
exports.FlattenTransformationSchema = exports.AbstractBaseTransformationSchema.extend({
    srcDataTape: exports.TapeDefinitionSchema,
    operation: zod_1.z.literal('flatten'),
    groupByField: zod_1.z.string().describe('Field to group by in the tape.'),
    aggregationFields: zod_1.z
        .array(exports.AggregationFieldSchema)
        .min(1)
        .describe('Fields to aggregate. Each field must have an inputField, outputField and aggregationFunction.'),
}).describe('FlattenTransformation');
exports.AbstractFieldModificationSchema = zod_1.z
    .object({
    type: zod_1.z.enum(['add_field', 'delete_field', 'rename_field']),
})
    .describe('AbstractFieldModification');
exports.FormulaFieldModificationSchema = exports.AbstractFieldModificationSchema.extend({
    type: zod_1.z.literal('add_field'),
    fieldConfig: finley_types_1.DataTapeField.BaseConfigSchema.describe('Field configuration for the new field to be added'),
    formula: zod_1.z
        .string()
        .describe('Formula to generate the field value. Accepts a row as input.'),
}).describe('FormulaFieldModification');
exports.DeletedFieldModificationSchema = exports.AbstractFieldModificationSchema.extend({
    type: zod_1.z.literal('delete_field'),
    field: zod_1.z.string().describe('Field name to be deleted from the tape'),
}).describe('DeletedFieldModification');
exports.RenameFieldModificationSchema = exports.AbstractFieldModificationSchema.extend({
    type: zod_1.z.literal('rename_field'),
    oldName: zod_1.z.string().describe('Old field name to be renamed'),
    newName: zod_1.z.string().describe('New field name to be used'),
}).describe('RenameFieldModification');
exports.FieldModificationSchema = zod_1.z
    .discriminatedUnion('type', [
    exports.FormulaFieldModificationSchema,
    exports.DeletedFieldModificationSchema,
    exports.RenameFieldModificationSchema,
])
    .describe('FieldModification');
exports.EditTransformationSchema = exports.AbstractBaseTransformationSchema.extend({
    srcDataTape: exports.TapeDefinitionSchema,
    operation: zod_1.z.literal('edit'),
    fieldModifications: zod_1.z
        .array(exports.FieldModificationSchema)
        .describe('Fields to be affected by the edit operation. See FieldModification.'),
}).describe('EditTransformation');
//# sourceMappingURL=transformation.js.map